import { customFetch } from "@/client/custom-fetch";

import {
  IFacebookLoginRequest,
  IForgotPasswordRequest,
  IGoogleLoginRequest,
  ILoginRequest,
  ILoginRequirePasscode,
  ILoginResponse,
  ITwoFactorRequest,
} from "./login.types";

export const loginApi = {
  login: (
    data: ILoginRequest
  ): Promise<ILoginResponse | ILoginRequirePasscode> => {
    return customFetch<ILoginResponse | ILoginRequirePasscode>("/login", {
      method: "POST",
      body: JSON.stringify({
        email: data.email,
        password: data.password,
      }),
      headers: {
        "Content-Type": "application/json",
        "g-recaptcha-response": data.reCaptchaToken || "",
      },
    });
  },

  loginWithGoogle: (
    data: IGoogleLoginRequest
  ): Promise<ILoginResponse | ILoginRequirePasscode> => {
    return customFetch<ILoginResponse | ILoginRequirePasscode>(
      "/user/login-with-google",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
  },

  loginWithFacebook: async (
    data: IFacebookLoginRequest
  ): Promise<ILoginResponse | ILoginRequirePasscode> => {
    return customFetch<ILoginResponse | ILoginRequirePasscode>(
      "/user/login-with-facebook",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
  },

  forgotPassword: (data: IForgotPasswordRequest): Promise<void> => {
    return customFetch<void>("/user/forgot-password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  },

  twoFactor: (data: ITwoFactorRequest): Promise<ILoginResponse> => {
    return customFetch<ILoginResponse>("/user/validate-passcode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  },
};
